var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.602,
    height: 17.152,
    viewBox: "0 0 19.602 17.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(-215.756 -340.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(215.756 339.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M0,1.225v9.8a1.225,1.225,0,0,0,1.225,1.225H4.9V0H1.225A1.225,1.225,0,0,0,0,1.225Z",
    transform: "translate(0 5.901)",
    fill: "#44d1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M11.214,6.155H7.595a.613.613,0,0,1-.536-.91l1.276-2.3A1.837,1.837,0,0,0,7.174.273l-.9-.225a.611.611,0,0,0-.6.184L.785,5.66A3.061,3.061,0,0,0,0,7.708v6.41a3.066,3.066,0,0,0,3.063,3.063H9.157a3.07,3.07,0,0,0,2.954-2.253l1.308-6a2.262,2.262,0,0,0-2.2-2.772Z",
    transform: "translate(6.126 0.97)",
    fill: "#44d1c0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbFill);
export default __webpack_public_path__ + "static/media/thumb-fill.804ad24caa8c0a8c0542f46bb55a41af.svg";
export { ForwardRef as ReactComponent };